import { ResetProcessPasswordForm } from "@/features"
import { authControllerValidateResetPasswordCode } from "@/shared/api/generated"
import { QUERY_KEYS, ROUTER_PATHS } from "@/shared/constants"
import { UiFullscreenSpinner } from "@/shared/ui"
import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"

export const ProcessResetPasswordPage = () => {
  const { code } = useParams()
  const navigate = useNavigate()

  const { data, isLoading, error } = useQuery({
    queryKey: QUERY_KEYS.RESET_PASSWORD_CODE(code ?? ""),
    queryFn: () => authControllerValidateResetPasswordCode(code ?? ""),
    select: data => data.email,
  })

  useEffect(() => {
    if (error) {
      navigate(ROUTER_PATHS.NOT_FOUND, { replace: true })
    }
  }, [error])

  if (isLoading || !data) {
    return <UiFullscreenSpinner />
  }

  if (!code) {
    return <Navigate to={ROUTER_PATHS.NOT_FOUND} replace />
  }

  return <ResetProcessPasswordForm email={data} code={code} />
}
